var site = window.site || {};
var $document = $(document);

(function ($, Drupal) {
  Drupal.behaviors.bambuserBlockV1 = {
    getButtons: function ($module, index) {
      var $triggers = $('.js-bambuser-block-video-play-cta', $module);

      if ($triggers.length) {
        $triggers = $triggers.eq(index - 1);
      }

      return $triggers;
    },

    attach: function (context, settings) {
      var self = this;
      var $modules = $('.js-bambuser-block--v1', context);

      if (!settings.bambuser_source) {
        return false;
      }
      if (!window.initBambuserLiveShopping) {
        window.initBambuserLiveShopping = function (item) {
          window.initBambuserLiveShopping.queue.push(item);
        };
        window.initBambuserLiveShopping.queue = [];
        var scriptNode = document.createElement('script');

        scriptNode['src'] = settings.bambuser_source;
        document.body.appendChild(scriptNode);
      }
      $modules.each(function () {
        self.init($(this));
      });
    },

    init: function ($module) {
      var self = this;
      var index = $module.data('button-index') || false;
      var streamId = $module.data('stream-id');

      if (streamId.length) {
        streamId = streamId.trim();
      }
      var linkImage = $module.data('link-image');

      if (linkImage) {
        var $images = $('.js-bambuser-block-video-play-image', $module);

        $images.each(function () {
          self.setup($(this), streamId);
        });
      }
      if (index) {
        var $elements = self.getButtons($module, index);

        $elements.each(function () {
          self.setup($(this), streamId);
        });
      }
    },

    setup: function ($elem, streamId) {
      if (!($elem && $elem.length) || $elem.hasClass('bambuser-initialized')) {
        return false;
      }
      var randomId = 'bambuser-trigger-' + Math.random().toString(36).substr(2, 9);

      if (!$elem.is('a')) {
        $elem.addClass('bambuser-clickable');
      }
      $elem.attr({
        'id': randomId,
        'role': 'button',
        'tabindex': 0,
        'href': 'javascript:void(0);'
      }).addClass('bambuser-initialized');
      window.initBambuserLiveShopping({
        showId: streamId,
        node: document.getElementById(randomId),
        type: 'overlay'
      });
      $elem.on('click.activate', function () {
        $document.trigger('bambuser.launched');
      });
    }
  };
})(jQuery, Drupal);
